import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getUNBLOCKIDCARDs(body = { keyword: '' }) {
        return Api().post('/UNBLOCKIDCARD/GetUNBLOCKIDCARDByCriteria', body);
    },
    /*  2. Get one column */

    getUNBLOCKIDCARD(id) {
        return Api().get(`/UNBLOCKIDCARD/${id}`);
    },
    /*  3. Create one column */

    saveUNBLOCKIDCARD(body) {
        return Api().post(`/UNBLOCKIDCARD`, body);
    },
    /*  4. Delete one or more columns */
    deleteUNBLOCKIDCARD(uNBLOCKIDCARD) {
        return Api().post(`/UNBLOCKIDCARD/DeleteUNBLOCKIDCARD`, uNBLOCKIDCARD);
    },
    /*  5. post one or more columns */
    postUNBLOCKIDCARD(uNBLOCKIDCARD) {
        return Api().post(`/UNBLOCKIDCARD/PostUNBLOCKIDCARD`, uNBLOCKIDCARD);
    }
};
